import React from "react";
import "../legalNotice/LegalNotice.scss";

export default function Accessibility() {
  return (
    <main id="main-content" className="legal-notice" tabIndex="-1">
      <a className="legal-notice__back" href="#/">
        ← Retour à l’accueil
      </a>

      <article>
        <h1>Accessibilité</h1>
        <p className="legal-notice__updated">
          Dernière mise à jour : 2 août 2026
        </p>

        <section>
          <h2>Notre engagement</h2>
          <p>
            KV2 s’engage à rendre le site <strong>simon.wf</strong> accessible
            au plus grand nombre, quels que soient les technologies, le matériel
            ou les aptitudes utilisés pour le consulter.
          </p>
        </section>

        <section>
          <h2>État de conformité</h2>
          <p>
            La conformité de ce site au Référentiel général d’amélioration de
            l’accessibilité (RGAA) n’a pas encore fait l’objet d’un audit
            complet. Aucun taux de conformité ne peut donc être communiqué à ce
            jour.
          </p>
        </section>

        <section>
          <h2>Mesures mises en œuvre</h2>
          <p>Le site intègre notamment les dispositifs suivants :</p>
          <ul>
            <li>un lien d’évitement vers le contenu principal ;</li>
            <li>
              une structure de titres et des zones de contenu identifiables ;
            </li>
            <li>une navigation utilisable au clavier ;</li>
            <li>
              une prise en compte de la préférence de réduction des animations ;
            </li>
            <li>un affichage adaptable aux différentes tailles d’écran ;</li>
            <li>un mode sombre respectant les préférences d’affichage.</li>
          </ul>
        </section>

        <section>
          <h2>Amélioration continue</h2>
          <p>
            L’accessibilité est prise en compte lors des évolutions du site. Des
            vérifications complémentaires restent nécessaires, notamment sur les
            contrastes, les contenus provenant de services tiers et la
            restitution avec différents lecteurs d’écran.
          </p>
        </section>

        <section>
          <h2>Signaler une difficulté</h2>
          <p>
            Si vous ne parvenez pas à accéder à un contenu ou à une
            fonctionnalité, contactez-nous en décrivant le problème rencontré.
            Nous chercherons une solution accessible ou vous transmettrons
            l’information sous une autre forme.
          </p>
          <p>
            <a
              href="https://kv2.fr/contact-postmaster/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contacter KV2 au sujet de l’accessibilité
            </a>
          </p>
        </section>
      </article>
    </main>
  );
}
